module.exports = __webpack_public_path__ + "static/media/campaigns.6646d2f8.svg";